module.exports = __webpack_public_path__ + "img/integration3.d86c3ba4.png";